module.exports = __webpack_public_path__ + "static/media/IMG_1392a.b3051e8d.jpg";